'use client'

import { useTranslations } from '@/lib/next-shim'

import { Button } from '@/components/ui/button'

type DeleteOrderDialogProps = {
  onCancel: () => void
  onConfirm: () => void
}

export function DeleteOrderDialog({ onCancel, onConfirm }: DeleteOrderDialogProps) {
  const t = useTranslations()

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg max-w-md w-full mx-4">
        <h2 className="text-lg font-semibold mb-2">{t('dialog.DeleteFilesConfirmation.title', { documents: 1 })}</h2>
        <p className="text-gray-600 mb-4">{t('dialog.DeleteFilesConfirmation.description')}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onCancel}>
            {t('button.cancel.label')}
          </Button>
          <Button variant="ghost" onClick={onConfirm} className="bg-red-50 text-red-600 hover:bg-red-100 hover:text-red-700">
            {t('button.confirm.label')}
          </Button>
        </div>
      </div>
    </div>
  )
}
